export default     {
    path: 'processes',
    name: 'processes',
    component: () => import(/* webpackChunkName: "bpmn-index" */ '@/views/admin/Processes/index.vue'),
    children:[
        {
            name: 'main',
            path: 'main',
            component: () => import(/* webpackChunkName: "bpmn-processes" */ '@/views/admin/Processes/BpmnProcesses.vue'),
            props: true,
        }
    ]
};
